module.exports = __webpack_public_path__ + "static/media/core.7215ff81.svg";